import { ErrorObject } from "ajv"
import { JSONSchema7 } from "json-schema"
import { DocumentExtraction } from "universal-schema/lib/1.0.0/document-schema"

export type JobSubmitData = JobSubmitDataRaw | JobSubmitDataUpload

export interface InputAndMetadata {
    input: unknown
    metadata?: unknown
}

export interface JobSubmitDataRaw {
    type: "raw"
    jobs: InputAndMetadata[]
    outputs?: DocumentExtraction
    isTrimmed: boolean
}

interface JobSubmitDataUpload {
    type: "upload"
    objectURL: string
    count: number
    isTrimmed: boolean
}

export function getCount(data: JobSubmitData): number {
    return data.type === "raw" ? data.jobs.length : data.count
}

export function getSchema(
    inputSchema: JSONSchema7,
    single: boolean
): JSONSchema7 {
    const arraySchema: JSONSchema7 = {
        type: "array",
        items: {
            type: "object",
            properties: {
                input: { ...inputSchema, definitions: undefined },
                metadata: {
                    type: "object"
                }
            },
            required: ["input"]
        },
        minItems: 1,
        ...(single && {
            maxItems: 1
        })
    }

    return {
        definitions: inputSchema.definitions,
        oneOf: [
            {
                type: "object",
                properties: {
                    type: { const: "raw" },
                    jobs: arraySchema
                },
                required: ["type", "jobs"]
            },
            {
                type: "object",
                properties: {
                    type: { const: "upload" },
                    objectURL: { type: "string" },
                    count: { type: "number" }
                },
                required: ["type", "objectURL", "count"]
            }
        ]
    }
}

export function fromInputs(inputs: unknown[], single: boolean): JobSubmitData {
    const trimmedInputs =
        !single || inputs.length <= 1 ? inputs : inputs.slice(0, 1)

    return {
        type: "raw",
        jobs: trimmedInputs.map(input => ({ input })),
        isTrimmed: trimmedInputs.length < inputs.length
    }
}

export function convertInputErrorPath(error: ErrorObject): ErrorObject[] {
    const pattern = /^\.jobs(?:(\[[\d]+\])\.input)*/

    if (!pattern.test(error.dataPath)) {
        return []
    }

    return [
        {
            ...error,
            dataPath: error.dataPath.replace(
                pattern,
                (_, matched) => matched ?? ""
            ) // remove programmatically added part
        }
    ]
}
